import RiskAssessmentConstraint from './RiskAssessmentConstraint'

export default RiskAssessmentConstraint
